export const INTEGRATION_LIST_REQUEST = "INTEGRATION_LIST_REQUEST"; 
export const INTEGRATION_LIST_SUCCESS = "INTEGRATION_LIST_REQUEST_SUCCESS";

export const INTEGRATION_CREATE_REQUEST = "INTEGRATION_CREATE_REQUEST"; 
export const INTEGRATION_DETAIL_REQUEST = "INTEGRATION_DETAIL_REQUEST"; 
export const INTEGRATION_ARCHIVE_REQUEST = "INTEGRATION_ARCHIVE_REQUEST"; 
export const INTEGRATION_DELETE_REQUEST = "INTEGRATION_DELETE_REQUEST";

export const CREATE_REMOTE_CONFIGURATION_REQUEST = "CREATE_REMOTE_CONFIGURATION_REQUEST";  
export const EDIT_REMOTE_CONFIGURATION_REQUEST = "EDIT_REMOTE_CONFIGURATION_REQUEST";  
export const DELETE_REMOTE_CONFIGURATION_REQUEST = "DELETE_REMOTE_CONFIGURATION_REQUEST";  

export const CREATE_PUSH_NOTIFICATION_REQUEST = "CREATE_PUSH_NOTIFICATION_REQUEST";  
export const EDIT_PUSH_NOTIFICATION_REQUEST = "EDIT_PUSH_NOTIFICATION_REQUEST";  
export const DELETE_PUSH_NOTIFICATION_REQUEST = "DELETE_PUSH_NOTIFICATION_REQUEST";  

export const INTEGRATION_UNARCHIVE_REQUEST = "INTEGRATION_UNARCHIVE_REQUEST"; 
export const INTEGRATION_EDIT_REQUEST = "INTEGRATION_EDIT_REQUEST"; 

export const INTEGRATION_CREATE_FORM_NAME = "createIntegration"; 
export const INTEGRATION_EDIT_FORM_NAME = "editIntegration";

export const INTEGRATION_AUTOCOMPLETE_REQUEST = "INTEGRATION_AUTOCOMPLETE_REQUEST";
export const INTEGRATION_AUTOCOMPLETE_SUCCESS = "INTEGRATION_AUTOCOMPLETE_SUCCESS";

export const INTEGRATION_ACTIVE_REQUEST = "INTEGRATION_ACTIVE_REQUEST"; 
export const INTEGRATION_DISABLED_REQUEST = "INTEGRATION_DISABLED_REQUEST"; 

export const INTEGRATION_SUBMIT_RULES = {
  name: {
    required: true,
  },
  platform: {
    required: true,
  },
  roleIds: {
    required: true,
    type: "array",
  },
};

export const READ_INTEGRATION = 249000;
export const CREATE_INTEGRATION = 249001;
export const UPDATE_INTEGRATION = 249002;
export const DELETE_INTEGRATION = 249003;
export const ARCHIVE_INTEGRATION = 249004;
export const UNARCHIVE_INTEGRATION = 249005;
export const ACTIVATE_INTEGRATION = 249011;
export const DISABLE_INTEGRATION = 249012;

export const READ_REMOTE_CONFIGURATION = 250000;
export const CREATE_REMOTE_CONFIGURATION = 250001;
export const UPDATE_REMOTE_CONFIGURATION = 250002;
export const DELETE_REMOTE_CONFIGURATION = 250003;
export const ARCHIVE_REMOTE_CONFIGURATION = 250004;
export const UNARCHIVE_REMOTE_CONFIGURATION = 250005;

export const READ_INTEGRATION_PUSH_NOTIFICATION = 266000;
export const WRITE_INTEGRATION_PUSH_NOTIFICATION = 266001;
export const UPDATE_INTEGRATION_PUSH_NOTIFICATION = 266002;
export const DELETE_INTEGRATION_PUSH_NOTIFICATION = 266003;

export const REMOTE_CONFIGURATION_TYPE_NUMBER = 1;
export const REMOTE_CONFIGURATION_TYPE_NUMBER_TITLE = "Number";

export const REMOTE_CONFIGURATION_TYPE_STRING = 2;
export const REMOTE_CONFIGURATION_TYPE_STRING_TITLE = "String";

export const REMOTE_CONFIGURATION_TYPE_BOOLEAN = 3;
export const REMOTE_CONFIGURATION_TYPE_BOOLEAN_TITLE = "Boolean";

export const REMOTE_CONFIGURATION_TYPE_OBJECT = 4;
export const REMOTE_CONFIGURATION_TYPE_OBJECT_TITLE = "Object";

export const REMOTE_CONFIGURATION_TYPE_ARRAY = 5;
export const REMOTE_CONFIGURATION_TYPE_ARRAY_TITLE = "Array";

export const REMOTE_CONFIGURATION_TYPE_DATA_SOURCE  = [
  {
    id: REMOTE_CONFIGURATION_TYPE_NUMBER,
    name: REMOTE_CONFIGURATION_TYPE_NUMBER_TITLE,
  },
  {
    id: REMOTE_CONFIGURATION_TYPE_STRING,
    name: REMOTE_CONFIGURATION_TYPE_STRING_TITLE,
  },
  {
    id: REMOTE_CONFIGURATION_TYPE_BOOLEAN,
    name: REMOTE_CONFIGURATION_TYPE_BOOLEAN_TITLE,
  },
  {
    id: REMOTE_CONFIGURATION_TYPE_OBJECT,
    name: REMOTE_CONFIGURATION_TYPE_OBJECT_TITLE,
  },
  {
    id: REMOTE_CONFIGURATION_TYPE_ARRAY,
    name: REMOTE_CONFIGURATION_TYPE_ARRAY_TITLE,
  }
];

export const INTEGRATION_STATUS_ACTIVE = 1; 
export const INTEGRATION_STATUS_ACTIVE_TITLE = "Active";
export const INTEGRATION_STATUS_DISABLED = 2; 
export const INTEGRATION_STATUS_DISABLED_TITLE = "Disable"; 

export const INTEGRATION_PLATFORM_IOS = 1; 
export const INTEGRATION_PLATFORM_IOS_TITLE = "iOS";
export const INTEGRATION_PLATFORM_ANDROID = 2; 
export const INTEGRATION_PLATFORM_ANDROID_TITLE = "Android"; 
export const INTEGRATION_PLATFORM_WEB_API = 3;
export const INTEGRATION_PLATFORM_WEB_API_TITLE = "Web App";

export const INTEGRATION_PLATFORM_DATA_SOURCE = [
  {
    id: INTEGRATION_PLATFORM_IOS,
    name: INTEGRATION_PLATFORM_IOS_TITLE,
    icon: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgNDAgNDgiIHdpZHRoPSI0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjOTk5Ij48cGF0aCBkPSJtMjkuMDUxMyAwcy0zLjU2LjA4NjczNTItNi44MjU0IDMuMzUxMTNjLTMuMjY1NCAzLjI2NDM5LTIuNzE0NCA3LjY2MzI3LTIuNzE0NCA3LjY2MzI3czMuMjMxOC41OTE0IDYuNjgxNS0yLjg1ODM0YzMuNDQ5Ny0zLjQ0OTY5IDIuODU4My04LjE1NjA2IDIuODU4My04LjE1NjA2eiIvPjxwYXRoIGQ9Im0xOS44ODUgMTMuNzk4N2MtMi40MDY5LS4wMTY3LTMuODg1My0yLjA5NDQtNy45ODM2LTIuMDk0NC0zLjY4ODE3IDAtNy4zODUyNSAyLjM3OTMtOC45NTczMiA0LjY4MTctMS41NjUxOCAyLjI5MTYtMi45MTk0Mjk0IDQuODA0OS0yLjkxOTQyOTQgOS45MDU1czIuNDU2MTc5NCAxMy44NzI3IDguNDk1MTA5NCAxOS44MTExYzEuMDMzOTMgMS4wMTcyIDIuNDAyOTQgMS43ODEgMy45NjUxNCAxLjgyODQgMi44MDkxLjA4NDcgNC41MzM5LTIuMDE3NiA4LjA4MjItMi4wMTc2IDMuNTQ4MiAwIDQuNjE1NyAyLjAxNzYgNy44MTg5IDIuMDE3NiAxLjQ1NjggMCAzLjExNzYtLjY2MzQgNC43MzExLTIuMzc5MyAyLjA2OTgtMi4yMDEgNC42MzgzLTYuMzkzOCA1Ljk0NjItMTAuNDE1MiAwIDAtNi41NTE0LTIuNTMwMS02LjQ3MjYtOS44MjM3LjA2NjEtNi4wNDQ4IDUuMTk5Mi05LjAxODUgNS4xOTkyLTkuMDE4NXMtMi45OTgzLTQuNzgwMy05LjM3MTMtNC43ODAzYy00LjQwMTguMDMzNS02LjM3MzEgMi4yOTk1LTguNTMzNiAyLjI4NDd6Ii8+PC9nPjwvc3ZnPg==",
  },
  {
    id: INTEGRATION_PLATFORM_ANDROID,
    name: INTEGRATION_PLATFORM_ANDROID_TITLE,
    icon: "data:image/svg+xml;base64,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",
  },
  {
    id: INTEGRATION_PLATFORM_WEB_API,
    name: INTEGRATION_PLATFORM_WEB_API_TITLE,
    icon: "data:image/svg+xml;base64,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",
  }
];

export const REMOTE_CONFIGURATION_SUBMIT_RULES = {
  key: {
    required: true,
  },
  value: {
    required: true,
  },
  type: {
    required: true,
  }
};

export const PUSH_NOTIFICATION_SUBMIT_RULES = {
  appId:{
    required:true
  },
  apiKey:{
    required:true
  },
  serviceName:{
    required:true
  }
};